import React, { useEffect } from "react";
import "./FoodMixesModal.css";

const FoodMixesModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fm-overlay" onClick={onClose}>
      <div className="fm-container" onClick={(e) => e.stopPropagation()}>
        <button className="fm-close" onClick={onClose}>&times;</button>

        <div className="fm-content">
          {/* Left — Text */}
          <div className="fm-text">
            <h1>WHERE NATURE MEETS SCIENCE</h1>

            <p>
              This is the philosophy of translating time-honoured botanicals into
              evidence-based health solutions. Nature provides complex phytochemicals,
              bioactives, and synergistic compounds. Science deciphers their mechanisms,
              validates their efficacy, and refines their use for modern health needs.
            </p>

            <p>
              Each formulation begins with selected plant sources like,
            </p>

            <ul className="fm-bullets">
              <li>Flowers</li>
              <li>Roots</li>
              <li>Leaves</li>
              <li>Seeds</li>
            </ul>

            <p>
              They are valued for their traditional relevance and diverse phytochemical
              composition, supporting natural physiological function.
            </p>

            <p>
              Traditional wisdom is strengthened by modern research. Each ingredient is
              supported by scientific literature, molecular insights, and physiological
              relevance — whether it's antioxidant signaling, metabolic regulation,
              gut-brain communication, or cellular resilience. This ensures safety,
              consistency, and real biological impact.
            </p>

            <p>
              Formulation is intentional, not accidental. Bioavailability, synergy, dosage,
              and metabolic compatibility are carefully considered so the body can recognize,
              absorb, and utilize what it receives. The result is sustained physiological
              support rather than short-term stimulation, working with the body's natural
              regulatory systems.
            </p>

            <blockquote className="fm-quote">
              "Rooted in Nature, Driven by Evidence &amp; Crafted for Health."
            </blockquote>

            <button className="fm-back-btn" onClick={onClose}>Back to Home</button>
          </div>

          {/* Right — Image */}
          <div className="fm-image">
            <img
              src="https://storage.googleapis.com/rasai-nutrie-assets/tiles/tile-4.png"
              alt="Where Nature Meets Science"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FoodMixesModal;
